import { useId } from 'react';

export type MascotExpression = 'idle' | 'thinking' | 'question' | 'success';

interface MascotProps {
  expression?: MascotExpression;
  size?: number;
  className?: string;
}

export function Mascot({ expression = 'idle', size = 40, className }: MascotProps) {
  const gradientId = useId();

  return (
    <svg
      viewBox="0 0 160 184"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="BKcito"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="var(--bk-accent)" />
          <stop offset="100%" stopColor="var(--bk-purple)" />
        </linearGradient>
      </defs>

      <g transform="translate(0, 42)">
      <rect x="10" y="10" width="140" height="130" rx="46" fill={`url(#${gradientId})`} />

      {expression === 'idle' && (
        <>
          <line x1="80" y1="10" x2="80" y2="-14" stroke="var(--bk-text-secondary)" strokeWidth="4" strokeLinecap="round" />
          <path d="M80,-28 L84,-17 L95,-13 L84,-9 L80,2 L76,-9 L65,-13 L76,-17 Z" fill="var(--bk-warning)" />
          <ellipse cx="62" cy="118" rx="10" ry="6" fill="var(--bk-blush)" opacity="0.55" />
          <ellipse cx="134" cy="114" rx="10" ry="6" fill="var(--bk-blush)" opacity="0.55" />
          <circle cx="58" cy="76" r="13" fill="#fff" />
          <circle cx="60" cy="75" r="5.5" fill="var(--bk-primary)" />
          <path d="M36,58 Q48,50 60,56" stroke="var(--bk-primary)" strokeWidth="3" fill="none" strokeLinecap="round" />
          <circle cx="104" cy="74" r="11.5" fill="#fff" />
          <circle cx="106" cy="73" r="5" fill="var(--bk-primary)" />
          <path d="M64,104 Q80,116 100,100" stroke="var(--bk-primary)" strokeWidth="4.5" fill="none" strokeLinecap="round" />
        </>
      )}

      {expression === 'thinking' && (
        <>
          <line x1="80" y1="10" x2="80" y2="-16" stroke="var(--bk-text-secondary)" strokeWidth="4" strokeLinecap="round" />
          <path d="M80,-34 L85,-21 L98,-16 L85,-11 L80,2 L75,-11 L62,-16 L75,-21 Z" fill="var(--bk-warning)" />
          <path d="M48,74 Q58,66 68,74" stroke="var(--bk-primary)" strokeWidth="4" fill="none" strokeLinecap="round" />
          <path d="M96,74 Q106,66 116,74" stroke="var(--bk-primary)" strokeWidth="4" fill="none" strokeLinecap="round" />
          <circle cx="70" cy="106" r="5" fill="var(--bk-primary)" opacity="0.85" />
          <circle cx="82" cy="106" r="5" fill="var(--bk-primary)" opacity="0.55" />
          <circle cx="94" cy="106" r="5" fill="var(--bk-primary)" opacity="0.3" />
        </>
      )}

      {expression === 'question' && (
        <>
          <line x1="80" y1="10" x2="80" y2="-14" stroke="var(--bk-text-secondary)" strokeWidth="4" strokeLinecap="round" />
          <path d="M80,-28 L84,-17 L95,-13 L84,-9 L80,2 L76,-9 L65,-13 L76,-17 Z" fill="var(--bk-warning)" />
          <circle cx="58" cy="78" r="13" fill="#fff" />
          <circle cx="60" cy="77" r="5.5" fill="var(--bk-primary)" />
          <path d="M92,66 Q106,56 120,64" stroke="var(--bk-primary)" strokeWidth="3" fill="none" strokeLinecap="round" />
          <circle cx="104" cy="76" r="11" fill="#fff" />
          <circle cx="106" cy="75" r="4.5" fill="var(--bk-primary)" />
          <circle cx="80" cy="112" r="5" fill="none" stroke="var(--bk-primary)" strokeWidth="3.5" />
        </>
      )}

      {expression === 'success' && (
        <>
          <line x1="80" y1="10" x2="80" y2="-18" stroke="var(--bk-text-secondary)" strokeWidth="4" strokeLinecap="round" />
          <path d="M80,-40 L87,-23 L104,-16 L87,-9 L80,8 L73,-9 L56,-16 L73,-23 Z" fill="var(--bk-warning)" />
          <path d="M48,72 Q58,62 68,72" stroke="var(--bk-primary)" strokeWidth="4" fill="none" strokeLinecap="round" />
          <path d="M96,72 Q106,62 116,72" stroke="var(--bk-primary)" strokeWidth="4" fill="none" strokeLinecap="round" />
          <path d="M60,100 Q80,122 100,100" stroke="var(--bk-primary)" strokeWidth="4.5" fill="none" strokeLinecap="round" />
          <circle cx="126" cy="40" r="15" fill="var(--bk-success)" />
          <path d="M119,40 L124,46 L134,33" stroke="#fff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </>
      )}
      </g>
    </svg>
  );
}
